
@if (isLoggedIn) {
  <ui-button [variant]="'danger'" (clicked)="logout()">
    Logout
  </ui-button>
} @else {
  <ui-button [variant]="'accent'" (clicked)="login()" [size]="'wide'" [tone]="'outline'">
    Log in
  </ui-button>
}

